'use strict';

var _ = require('lodash');
var encode = require('hashcode').hashCode;
var SortCriteriaFactory = function SortCriteriaFactory(SortColumn) {
  var MAX_SORTING_COLUMNS = 7;
  function SortCriteria() {
    this.customSort = false;
    this.columns = {};
    this.columnKeys = [];
    this.lastResetIdx = 0;
    this.reset();
    var sortColumns = Array.isArray(arguments[0]) ? arguments[0].slice(0, MAX_SORTING_COLUMNS) : Array.prototype.slice.call(arguments, 0, MAX_SORTING_COLUMNS);
    sortColumns.forEach(_.bind(function (sortColumn) {
      if (sortColumn instanceof SortColumn) {
        this.add(sortColumn);
      }
    }, this));
  }
  function sortIterationKeys(keys) {
    keys.sort(function (a, b) {
      return a.indexOf('_') === 0 ? 1 : b.indexOf('_') === 0 ? -1 : 0;
    });
  }
  SortCriteria.MAX_SORTING_COLUMNS = MAX_SORTING_COLUMNS;
  SortCriteria.prototype.add = function (sortColumn) {
    if (sortColumn instanceof SortColumn) {
      this.columnKeys.push(sortColumn.field);
      this.columns[sortColumn.field] = sortColumn;
      sortIterationKeys(this.columnKeys);
      if (this.columnKeys.length > MAX_SORTING_COLUMNS) {
        delete this.columns[this.columnKeys.pop()];
      }
    }
  };
  SortCriteria.prototype.getActiveSortColumn = function (field) {
    return this.columns[field];
  };
  SortCriteria.prototype.getActiveSortColumnFields = function () {
    return Object.keys(this.columns).filter(_.bind(function (id) {
      return !this.columns[id].isNotSorted();
    }, this));
  };
  SortCriteria.prototype.getActiveSortColumns = function () {
    return this.columnKeys.slice().map(_.bind(function (key) {
      return this.columns[key];
    }, this)).filter(function (column) {
      return !column.isNotSorted();
    });
  };
  SortCriteria.prototype.getSortColumns = function () {
    return this.columnKeys.slice().map(_.bind(function (key) {
      return this.columns[key];
    }, this));
  };
  SortCriteria.prototype.isCustomSort = function () {
    return this.customSort;
  };
  SortCriteria.prototype.setIsCustomSort = function (customSort) {
    this.customSort = customSort;
  };
  SortCriteria.prototype.hasNext = function () {
    return this.index < this.columnKeys.length;
  };
  SortCriteria.prototype.next = function () {
    this.lastIdx = this.index;
    return this.columns[this.columnKeys[this.index++]];
  };
  SortCriteria.prototype.getFieldsAsString = function () {
    return this.getActiveSortColumns().map(function (sortColumn) {
      return sortColumn.getFieldAlias() || sortColumn.field;
    }).join(',');
  };
  SortCriteria.prototype.getDirsAsString = function () {
    return this.getActiveSortColumns().map(function (column) {
      return column.sortDirection.ascending ? 'ASC' : 'DESC';
    }).join(',');
  };
  SortCriteria.prototype.reset = function () {
    this.columnKeys.length = 0;
    Object.keys(this.columns).forEach(_.bind(function (key) {
      delete this.columns[key];
    }, this));
    for (var c = 0, l = MAX_SORTING_COLUMNS; c < l; c++) {
      this.add(new SortColumn('_' + this.lastResetIdx));
      this.lastResetIdx++;
    }
    this.lastIdx = undefined;
    this.index = 0;
  };
  SortCriteria.prototype.toExportFormat = function () {
    return this.getActiveSortColumns().map(function (column) {
      return column.toExportFormat();
    });
  };
  SortCriteria.prototype.toJQXSortCriteria = function () {
    var columns = [],
      directions = [];
    this.getActiveSortColumns().forEach(function (column) {
      if (column.field !== '') {
        columns.push(column.field);
        directions.push(column.getSortDirection());
      }
    });
    return {
      columns: columns.join(','),
      directions: directions.join(',')
    };
  };
  SortCriteria.prototype.hashCode = function () {
    var columns = this.toExportFormat().map(function (column) {
      return column.field + '-' + column.direction;
    });
    return encode().value(columns.join('-'));
  };
  SortCriteria.prototype.clone = function () {
    var sortCriteria, sortColumns;
    sortColumns = this.getActiveSortColumns().map(function (column) {
      return column.clone();
    });
    sortCriteria = new SortCriteria(sortColumns);
    sortCriteria.setIsCustomSort(this.isCustomSort());
    return sortCriteria;
  };
  SortCriteria.prototype.toString = function () {
    return '';
  };
  return SortCriteria;
};
SortCriteriaFactory.$inject = ['SortColumnFactory'];
module.exports = SortCriteriaFactory;